
import storeCode from '~/mixins/storeCode'

export default {
  name: 'CheckoutHeaderCart',

  mixins: [
    storeCode,
  ],
}
